import {useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import LinkStyled from "shared/ui/LinkStyled";
import AuthCardLayout from "../components/AuthCardLayout";
import ChangePasswordForm from "../components/ChangePasswordForm";
import ForgotPasswordForm from "../components/ForgotPasswordForm";

const ForgotPasswordTeachers = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    return (
        <Grid container spacing={4} justifyContent="center">
            <AuthCardLayout image="/images/account-type-2.svg" title="Brio în clasă" size="large" showBackButton={true}>
                <Typography variant="h2" sx={{marginBottom: 2}}>Resetează parola</Typography>
                {token ? <ChangePasswordForm type="teacher"/> : <ForgotPasswordForm type="teacher"/>}
                <LinkStyled to="/login/profesori">Autentificare</LinkStyled>
            </AuthCardLayout>
        </Grid>
    );
};

export default ForgotPasswordTeachers;
